export const themeNameMap: Record<string, string> = {
  blue_and_yellow: 'blue_yellow_uss_signal',
  dark_and_light_blue: 'virtual_one',
  deep_sky_blue: 'deep_sky_itkontoret',
  default: 'default',
  green: 'green_also_choise_df',
  light_blue: 'light_blue_hp',
  magenta: 'telstra',
  orange: 'orange_tsukaeru_helpox',
  purple: 'purple_fusion_media',
  red: 'red_home_pl',
  red_fire_brick: 'red_fire_brick',
  scheme_2: 'purple',
  scheme_3: 'brown',
  scheme_4: 'ingram_micro',
  scheme_5: 'sand',
  scheme_7: 'light_gray',
  scheme_8: 'dark_gray',
  yellow: 'yellow_1c',
  deep_purple: 'deep-purple',
  pinky: 'pinky'
};

export function getThemeName(name: string): string {
  return themeNameMap[name] || name;
}
